"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuneralPyreAbilityHandler = exports.FuneralPyreActorAbilityFactory = exports.FuneralPyreAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_1 = require("../../core/vfx/core");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class FuneralPyreAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FuneralPyre;
        this.__typeName = "FuneralPyre";
    }
}
exports.FuneralPyreAbilityArgs = FuneralPyreAbilityArgs;
let FuneralPyreActorAbilityFactory = class FuneralPyreActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FuneralPyre", "AllEnemies", 3);
    }
};
FuneralPyreActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FuneralPyre")
], FuneralPyreActorAbilityFactory);
exports.FuneralPyreActorAbilityFactory = FuneralPyreActorAbilityFactory;
let FuneralPyreAbilityHandler = class FuneralPyreAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: enemies.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 70)
                ],
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "PurpleEvilMeteorShower")),
            onHit: (sequence, target) => {
                container.applyDebuff({
                    sequence: sequence,
                    attackerId: ability.invokerId,
                    targetId: target.targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.BurningEffectArgs("Focus", 10),
                });
            }
        });
    }
};
FuneralPyreAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FuneralPyre)
], FuneralPyreAbilityHandler);
exports.FuneralPyreAbilityHandler = FuneralPyreAbilityHandler;
